"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jrlDebug = void 0;
const tslib_1 = require("tslib");
const debug_1 = tslib_1.__importDefault(require("debug"));
exports.jrlDebug = debug_1.default('json-react-layout');
//# sourceMappingURL=log.js.map